import {
    useEffect,
    useState,
} from 'react';

import api from '../../api/api';

import AdminLayout from './Components/AdminLayout';
import DietaryPreferenceModal from "./Components/DietaryPreferenceModal";

export default function AdminDietaryPreference()
{
    const [dietaryPreferences, setDietaryPreferences] =
        useState<any[]>([]);

    const [modalOpen, setModalOpen] =
        useState(false);

    const [selectedDietaryPreference, setSelectedDietaryPreference] =
        useState<any>(null);

    const loadDietaryPreferences = async () => {

        const response =
            await api.get(
                '/dietarypreferences'
            );

        setDietaryPreferences(
            response.data
        );
    };

    useEffect(() => {

        loadDietaryPreferences();

    }, []);

    const handleSave = async (
        data: FormData
    ) => {

        if (
            selectedDietaryPreference
        ) {

            await api.post(

                `/dietarypreferences/${selectedDietaryPreference.id}?_method=PUT`,

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );

        } else {

            await api.post(

                '/dietarypreferences',

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );
        }

        setModalOpen(
            false
        );

        setSelectedDietaryPreference(
            null
        );

        loadDietaryPreferences();
    };

    const handleDelete = async (
        id: number
    ) => {

        if (
            !window.confirm(
                'Delete this dietary preference?'
            )
        ) {
            return;
        }

        await api.delete(
            `/dietarypreferences/${id}`
        );

        loadDietaryPreferences();
    };

    const moveDietaryPreferenceUp = async (
        index: number
    ) => {

        if (
            index <= 0
        ) {
            return;
        }

        const updated =
            [...dietaryPreferences];

        [
            updated[index - 1],
            updated[index]
        ] = [
            updated[index],
            updated[index - 1]
        ];

        setDietaryPreferences(
            updated
        );

        await api.post(
            '/dietarypreferences/reorder',
            {
                dietaryPreferences:
                    updated.map(
                        (
                            dietaryPreference,
                            position
                        ) => ({
                            id:
                            dietaryPreference.id,

                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadDietaryPreferences();
    };

    const moveDietaryPreferenceDown = async (
        index: number
    ) => {

        if (
            index >=
            dietaryPreferences.length - 1
        ) {
            return;
        }

        const updated =
            [...dietaryPreferences];

        [
            updated[index],
            updated[index + 1]
        ] = [
            updated[index + 1],
            updated[index]
        ];

        setDietaryPreferences(
            updated
        );

        await api.post(
            '/dietarypreferences/reorder',
            {
                dietaryPreferences:
                    updated.map(
                        (
                            dietaryPreference,
                            position
                        ) => ({
                            id:
                            dietaryPreference.id,

                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadDietaryPreferences();
    };

    return (

        <AdminLayout>

            <div className="page-header">

                <h1>
                    Dietary Preferences
                </h1>

                <button
                    className="action-btn"
                    onClick={() => {

                        setSelectedDietaryPreference(
                            null
                        );

                        setModalOpen(
                            true
                        );

                    }}
                >
                    Add Dietary Preference
                </button>

            </div>

            <table className="users-table">

                <thead>

                <tr>

                    <th>
                        Name
                    </th>

                    <th>
                        Active
                    </th>

                    <th>
                        Actions
                    </th>

                </tr>

                </thead>

                <tbody>

                {dietaryPreferences.map(
                    (
                        dietaryPreference,
                        index
                    ) => (

                        <tr
                            key={
                                dietaryPreference.id
                            }
                        >

                            <td>
                                {
                                    dietaryPreference.name
                                }
                            </td>

                            <td>
                                {
                                    dietaryPreference.is_active
                                        ? 'Yes'
                                        : 'No'
                                }
                            </td>

                            <td>

                                <div className="actions">

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveDietaryPreferenceUp(
                                                index
                                            )
                                        }
                                    >
                                        ▲
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveDietaryPreferenceDown(
                                                index
                                            )
                                        }
                                    >
                                        ▼
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() => {

                                            setSelectedDietaryPreference(
                                                dietaryPreference
                                            );

                                            setModalOpen(
                                                true
                                            );

                                        }}
                                    >
                                        Edit
                                    </button>

                                    <button
                                        className="delete-btn"
                                        onClick={() =>
                                            handleDelete(
                                                dietaryPreference.id
                                            )
                                        }
                                    >
                                        Delete
                                    </button>

                                </div>

                            </td>

                        </tr>

                    )
                )}

                </tbody>

            </table>

            {modalOpen && (

                <DietaryPreferenceModal

                    dietaryPreference={
                        selectedDietaryPreference
                    }

                    onClose={() =>
                        setModalOpen(
                            false
                        )
                    }

                    onSave={
                        handleSave
                    }

                />

            )}

        </AdminLayout>

    );
}
